var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmoji4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 16C31 24.3 24.3 31 16 31C7.7 31 1 24.3 1 16C1 7.7 7.7 1 16 1C24.3 1 31 7.7 31 16Z",
    fill: "#FDE047"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 19C24.5 18.6 24.25 18.1001 23.6 17.9501C21.85 17.6001 19.3 17.3 16 17.3C12.7 17.3 10.15 17.6501 8.4 17.9501C7.75 18.1001 7.5 18.6 7.5 19C7.5 22.65 10.3 26.3 16 26.3C21.7 26.3 24.5 22.65 24.5 19Z",
    fill: "#664E27"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2499 13.45C13.2999 10.9 11.8999 9.59998 10.4999 9.59998C9.09986 9.59998 7.69986 10.9 6.74986 13.45C6.64986 13.7 7.14986 14.15 7.39986 13.9C8.29986 12.95 9.39986 12.55 10.4999 12.55C11.5999 12.55 12.6999 12.95 13.5999 13.9C13.8999 14.15 14.3499 13.7 14.2499 13.45Z",
    fill: "#664E27"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2001 13.45C24.2501 10.9 22.8501 9.59998 21.4501 9.59998C20.0501 9.59998 18.6501 10.9 17.7001 13.45C17.6001 13.7 18.1001 14.15 18.3501 13.9C19.2501 12.95 20.3501 12.55 21.4501 12.55C22.6001 12.55 23.6501 12.95 24.5501 13.9C24.8001 14.15 25.3001 13.7 25.2001 13.45Z",
    fill: "#664E27"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3502 19.15C21.2502 18.95 18.9502 18.65 16.0002 18.65C13.0502 18.65 10.7502 18.95 9.65022 19.15C9.00022 19.25 8.95022 19.5 9.00022 19.9C9.05022 20.1 9.05022 20.4 9.15022 20.7C9.20022 21 9.30022 21.15 9.80022 21.1C10.7502 21 21.3002 21 22.2502 21.1C22.7502 21.15 22.8002 21 22.9002 20.7C22.9502 20.4 23.0002 20.15 23.0502 19.9C23.0502 19.5 23.0002 19.25 22.3502 19.15Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3502 19.15C21.2502 18.95 18.9502 18.65 16.0002 18.65C13.0502 18.65 10.7502 18.95 9.65022 19.15C9.00022 19.25 8.95022 19.5 9.00022 19.9C9.05022 20.1 9.05022 20.4 9.15022 20.7C9.20022 21 9.30022 21.1 9.80022 21.1H22.2502C22.7502 21.1 22.8002 21 22.9002 20.7C22.9502 20.4 23.0002 20.15 23.0502 19.9C23.0502 19.5 23.0002 19.25 22.3502 19.15Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoji4);
export default __webpack_public_path__ + "static/media/emoji_4.7220b7629a8c9ec7d844116be67d9777.svg";
export { ForwardRef as ReactComponent };